// extracted by mini-css-extract-plugin
export var chevron = "_kg-3";
export var chevronRotated = "_kg-4";
export var image = "_kg-1";
export var imageContainer = "_kg-0";
export var shippingAddress = "_kg-2";